import React from 'react';
import { ColorGreyLight, bezier, colorOrange } from '../styles/sharedStyles';
import styled from 'styled-components'

const QuestionsCounter = styled.div`
position: absolute;
width: 80%;
height: .5rem;
top: ${props => props.top || .75}rem;
left: 10%;

background-color: ${ColorGreyLight};
border-radius: 2rem;
overflow: hidden;

.indicator {
    position: absolute;
    width: ${props => props.width}%;
    height: .5rem;
    top: 0;
    left: 0;
    transition: all 1s ${bezier};

    z-index: 100;

    background-color: ${props => props.width === 100 ? `${colorOrange}}` : props.color};
    border-radius: 2rem;
}
`
const QuestionCounterElement = ({width, top, color}) => {
    return ( 
        <QuestionsCounter
            width={width}
            top={top}
            color={color}
        >
            <div className="indicator"/>
        </QuestionsCounter>
     );
}
 
export default QuestionCounterElement;